'use client';
import routes from '@config/routes';
import { serverFetcher } from '@instance';
import { getComparableLeagueCodes } from '@utils/config/leagues';
import {
  getEuropeanSoccerOpponents,
  getEuropeanSoccerTeamsByCategory,
} from '@v2/services/getTeamsByLeague/europeanSoccer';
import { useState } from 'react';
import useSWR from 'swr';
import { OpponentsDropdownFilter } from '../components/OpponentsDropdownFilter';

export const OponnetsDropdownWrapper = ({
  leagueSlug,
  teamSlug,
  selectedValue,
  onOpponentChange,
  defaultLabel,
  compactMobile,
}) => {
  const [filteredItems, setFilteredItems] = useState<any>();
  const comparableLeagueCodes = new Set(getComparableLeagueCodes(leagueSlug));

  // TODO: Remove this local fallback once GET /teams includes performers for
  // english-premier-league, la-liga, italian-serie-a, bundesliga, and ligue-1.
  const europeanTeams = getEuropeanSoccerTeamsByCategory(leagueSlug);
  const isEuropeanSoccerLeague = europeanTeams.length > 0;
  const europeanOpponents = isEuropeanSoccerLeague
    ? getEuropeanSoccerOpponents(leagueSlug, teamSlug)
    : undefined;

  const { data: apiOpponentsList } = useSWR(
    isEuropeanSoccerLeague ? null : routes.getHeaderTeams,
    (url) =>
      serverFetcher(url, { method: 'GET' }).then((response) => {
        if (!response) return [];
        return response.filter((team) => {
          const isCurrentTeam =
            team.team.toLowerCase() ===
            teamSlug.replaceAll('-', ' ').toLowerCase();
          return (
            comparableLeagueCodes.has(team.league.toLowerCase()) &&
            !isCurrentTeam
          );
        });
      })
  );

  const opponentsList = europeanOpponents ?? apiOpponentsList;

  const onSearch = (value: string) => {
    if (value.length > 2 && opponentsList?.length > 0) {
      setFilteredItems(() => {
        return opponentsList.filter((item) => {
          const teamName = item.team.toLowerCase().split(' ');
          return (
            teamName.some((sentence) =>
              sentence.startsWith(value.toLowerCase())
            ) || item.team.toLowerCase().startsWith(value.toLowerCase())
          );
        });
      });
    } else {
      setFilteredItems(undefined);
    }
  };

  return (
    <OpponentsDropdownFilter
      selectedValue={selectedValue}
      onOpponentChange={onOpponentChange}
      teams={filteredItems || opponentsList}
      onSearch={onSearch}
      defaultLabel={defaultLabel}
      compactMobile={compactMobile}
    />
  );
};
